import { START } from 'shared/data/quoteSteps';
import defaultParameters from 'offshore_pcb/pcb_fabrication/data/defaultParameters';
import defaultQuote from 'offshore_pcb/pcb_fabrication/data/defaultQuote';

const state = {
  loading: false,
  destroy: false,
  parametersChanged: false,
  quantitiesChanged: false,
  quoteStep: START,
  quote: defaultQuote,
  parameters: defaultParameters,
  lineItemId: null,
  currentVariant: null,
};

export default state;
